import { render, staticRenderFns } from "./HeaderSpotlight.vue?vue&type=template&id=4d2abca4&scoped=true&"
import script from "./HeaderSpotlight.vue?vue&type=script&lang=js&"
export * from "./HeaderSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSpotlight.vue?vue&type=style&index=0&id=4d2abca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2abca4",
  null
  
)

export default component.exports